import {
    FETCH_ADMINPERMISSIONS_BEGIN,
    FETCH_ADMINPERMISSIONSTENANT_SUCCESS,
    FETCH_ADMINPERMISSIONS_FAILURE,    
    FETCH_ADMINTHEMES_BEGIN,
    FETCH_ADMINTHEMELIST_SUCCESS,
    FETCH_ADMINTHEME_SUCCESS,
    FETCH_ADMINREPORT_SUCCESS,
    FETCH_ADMINREPORTPART_SUCCESS,
    FETCH_ADMINREPORTPARTLIST_SUCCESS,
    FETCH_ADMINTHEMEDETAILS_SUCCESS,
    FETCH_ADMINTHEMES_FAILURE,            
    } from '../constants/adminPermissions';

const initialState={
    TenantData:[],  
    ThemeListData:[], 
    ThemeData:[],
    ReportData:[],
    ThemeGridData:[],
    ReportPartListData:[],
    ReportPartListByIdData:[],
    error:""
}


export const getAdminPermissionsReducer = (state=initialState,action) => {
    const {type,payload}=action;
 switch(type)
 {       
    case FETCH_ADMINPERMISSIONS_BEGIN: 
        return {
          ...state,
          isLoading: true,
          error: null,
        };
    case FETCH_ADMINPERMISSIONS_FAILURE:
        return {
            ...state,
            isLoading:true,
            error:payload.error
        };
    case FETCH_ADMINPERMISSIONSTENANT_SUCCESS:
        return {
            ...state,
            isLoading:false,
            TenantData:payload.TenantData
        };
    case FETCH_ADMINTHEMES_BEGIN: 
    return {
        ...state,
        isLoading: true,
        error: null,
    };
    case FETCH_ADMINTHEMES_FAILURE:
        return {
            ...state,
            isLoading:true,
            error:payload.error
        };
    case FETCH_ADMINTHEMELIST_SUCCESS:
        return {
            ...state,
            isLoading:false,
            ThemeListData:payload.ThemeListData
        };
    case FETCH_ADMINTHEME_SUCCESS:
        return {
            ...state,
            isLoading:false,
            ThemeData:payload.ThemeData
        };
    case FETCH_ADMINREPORT_SUCCESS:
        return {
            ...state,
            isLoading:false,
            ReportData:payload.ReportData
        };
    case FETCH_ADMINTHEMEDETAILS_SUCCESS:
        return {
            ...state,
            isLoading:false,
            ThemeGridData:payload.ThemeGridData
        };
    case FETCH_ADMINREPORTPART_SUCCESS:
        return {
            ...state,
            isLoading:false,
            ReportPartListData:payload.ReportPartListData
        };
    case FETCH_ADMINREPORTPARTLIST_SUCCESS:
        return {
            ...state,
            isLoading:false,
            ReportPartListByIdData:payload.ReportPartListByIdData
        };

    default:
        return state;
 }
}

export default getAdminPermissionsReducer
